import { ListWithPagination } from '@anytag/shared-molecules';
import { useYoutubeAnalyticsTrendsQuery } from '@anytag/graphql';
import { CountryOption, SelectOption } from '@anytag/shared-types';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import {
  TrendingPostsList,
  TrendingPostsFilter,
  TrendingPostsTabType,
  useTrendingPostsFilter
} from '@anytag/shared-organisms';

interface TrendingYoutubePostsProps {
  allCountryOptions: CountryOption[];
  allCategoryOptions: SelectOption<string>[];
}
export const TrendingYoutubePosts = ({ allCountryOptions, allCategoryOptions }: TrendingYoutubePostsProps) => {
  const { page, limit, filter } = useTrendingPostsFilter();
  const { data, previousData, loading } = useYoutubeAnalyticsTrendsQuery({
    skip: !filter.categoryId || !filter.countryId,
    fetchPolicy: 'cache-and-network',
    variables: getValuableVariables({
      limit,
      offset: getOffset(page, limit),
      date: filter.date,
      country: filter.countryId,
      category: Number(filter.categoryId)
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.youtubeAnalyticsTrendsCount.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <TrendingPostsFilter allCountryOptions={allCountryOptions} allCategoryOptions={allCategoryOptions} />
      <TrendingPostsList
        loading={loading}
        tab={TrendingPostsTabType.YOUTUBE}
        data={result?.youtubeAnalyticsTrends.posts || []}
      />
    </ListWithPagination>
  );
};
